import { rootApi } from "../../api/rootApi";

export const bulkScanHistoryApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchBulkScanHistory: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/bulkScanHistory/`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchBulkScanDetails: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/bulkScanHistory/details`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchBulkScanHistoryMutation,
  useFetchBulkScanDetailsMutation,
} = bulkScanHistoryApi;
